import * as React from 'react';
import {
  Box,
} from '@mui/material';


import { AboutUsComp, AboutUsContent, TextBody, TextContent, TextTitle, VideoContent } from './styles';
import VideoPlayer from '../../../VideoPlayer/VideoPlayer';
import videoFile from '../../../../assets/videos/video_bhbusmidia_compressed.mp4';
import thumbnail from '../../../../assets/videos/thumbnail.png';

// Adicione uma imagem de placeholder (thumbnail)
const videoThumbnail = thumbnail; // Use uma imagem relevante como placeholder

const videoJsOptions = {
  sources: [
    {
      src: videoFile,
      type: "video/mp4"
    }
  ]
};

const NossaSolucao: React.FC = () => {
  const [playVideo, setPlayVideo] = React.useState(false);

  const handlePlayClick = () => {
    setPlayVideo(true);
  };

  return (
    <AboutUsComp id='nossol'>
      <AboutUsContent>
        <TextContent>
          <TextTitle>
            <h1>NOSSA SOLUÇÃO</h1>
            <h2>Porque somos a melhor opção?</h2>
          </TextTitle>
          <TextBody>
            <p>
              O <strong>Backbus</strong> é uma mídia OOH, o formato permite que toda a traseira seja utilizada para exibição da sua marca!
            </p>
            <p>
              Essa mídia alcança um alto número de pessoas trazendo mais visibilidade para quem anuncia. É a mídia em movimento, com mais impacto para as empresas, de forma eficaz e rentável.
            </p>
          </TextBody>
        </TextContent>
        <VideoContent>
          {playVideo ? (
            <VideoPlayer options={videoJsOptions} />
          ) : (
            <Box
              sx={{
                position: 'relative',
                width: '100%',
                height: '100%',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onClick={handlePlayClick}
            >
              <img
                src={videoThumbnail}
                alt="Video Thumbnail"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  width: '60px',
                  height: '60px',
                  background: 'rgba(0, 0, 0, 0.6)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <svg width="30" height="30" viewBox="0 0 24 24" fill="#fff">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </Box>
            </Box>
          )}
        </VideoContent>
      </AboutUsContent>
    </AboutUsComp>
  );
};

export { NossaSolucao };